import { CheckCircleOutlined } from '@ant-design/icons';
import { type NotificaResponseDTO } from '@framework/api-client/api/backoffice/schemas/notificaResponseDTO.ts';
import { ButtonIcon } from '@framework/ui/components/button/ButtonIcon.tsx';
import { useTranslation } from 'react-i18next';
import { useMarkNotificationAsRead } from '../detail/useMarkNotificationAsRead.ts';

interface IMarkAsReadButtonProps {
  notification: NotificaResponseDTO;
}

/**
 * Pulsante icona per segnare una notifica come letta nella tabella.
 * Visibile solo se la notifica non è ancora stata letta.
 */
export function MarkAsReadButton({ notification }: IMarkAsReadButtonProps) {
  const { t } = useTranslation();
  const { markAsRead, isRead } = useMarkNotificationAsRead({
    notificationId: notification.id ?? '',
    read: notification.dataPresaVisione,
  });

  if (isRead) return null;

  const label = t('notifiche.segna-come-letta', 'Segna come letta');

  return (
    <ButtonIcon
      aria-label={label}
      icon={<CheckCircleOutlined aria-hidden="true" />}
      tooltip={label}
      tooltipProps={{ placement: 'bottomRight' }}
      onClick={markAsRead}
    />
  );
}
